import { DropdownProps } from '@lyra/core/components/Dropdown'
import { SectionProps } from '@lyra/core/components/Section'
import useSubaccount from '@lyra/web/hooks/useSubaccount'

import SubaccountDropdownSection from '../common/SubaccountDropdownSection'

type Props = {
  placement?: DropdownProps['placement']
} & SectionProps

export default function TradeSubaccountSection(sectionProps: Props) {
  const { subaccount, switchSubaccount } = useSubaccount()

  return (
    <SubaccountDropdownSection
      {...sectionProps}
      showAccountValue
      showActions
      subaccountId={subaccount?.subaccount_id}
      onSelect={switchSubaccount}
    />
  )
}
